import { useTranslation } from '@frontend/i18n';
import { AudienceTray } from '../audience-tray/audience-tray';

type Props = {
  cancelCreateList: () => void;
};

export const UploadViewHeader = ({ cancelCreateList }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  return <AudienceTray.Header title={t('Upload CSV List')} onBackClick={cancelCreateList} />;
};
